import {
  EDIT_CONSULTATION,
  DELETE_CONSULTATION,
  UPDATE_CONSULTATION_SUCCESS,
  UPDATE_CONSULTATION,
  DELETE_CONSULTATION_SUCCESS,
  FETCH_ALL_CONSULTATION,
  FETCH_ALL_CONSULTATION_SUCCESS,
  FILTER_CONSULTATION,
  FILTER_CONSULTATION_SUCCESS,
  SET_CONSULTATION,
  CREATE_CONSULTATION_SUCCESS,
  CONSULTATION_POPUP_STATUS_CHANGE,
  FETCH_CHATS,
  FETCH_CHATS_SUCCESS,
  FETCH_CALLS,
  FETCH_CALLS_SUCCESS,
  CREATE_CALL_EVENT_SUCCESS,
} from "constants/consultation.constants";
import { startLoader } from "actions/general.action";

export const setConsultation = (key, value) => {
  return {
    type: SET_CONSULTATION,
    key: key,
    value: value,
  };
};

export const fetchConsultations = (page) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ALL_CONSULTATION,
      payload: page,
    });
    dispatch(startLoader());
  };
};

export const fetchConsultationsSuccess = (data) => {
  return {
    type: FETCH_ALL_CONSULTATION_SUCCESS,
    payload: data,
  };
};

export const filterConsultations = (search_key, search_value, page) => {
  return (dispatch) => {
    dispatch({
      type: FILTER_CONSULTATION,
      payload: { key: search_key, value: search_value, page: page },
    });
    dispatch(startLoader());
  };
};

export const filterConsultationsSuccess = (data) => {
  return {
    type: FILTER_CONSULTATION_SUCCESS,
    payload: data,
  };
};

export const deleteConsultation = (id) => {
  return {
    type: DELETE_CONSULTATION,
    payload: id,
  };
};

export const editConsultation = (id) => {
  return {
    type: EDIT_CONSULTATION,
    payload: id,
  };
};

export const updateConsultationSuccess = (data) => {
  return {
    type: UPDATE_CONSULTATION_SUCCESS,
    payload: data,
  };
};

export const deleteConsultationSuccess = (data) => {
  return {
    type: DELETE_CONSULTATION_SUCCESS,
    payload: data,
  };
};

export const updateConsultation = (payload) => {
  return {
    type: UPDATE_CONSULTATION,
    payload: payload,
  };
};

export const createdRoom = (payload) => {
  return {
    type: CREATE_CONSULTATION_SUCCESS,
    payload: payload,
  };
};

export const createEvent = (payload) => {
  return {
    type: CREATE_CALL_EVENT_SUCCESS,
    payload: payload,
  };
}

export const openPopup = (data) => {
  return {
    type: CONSULTATION_POPUP_STATUS_CHANGE,
    payload: data,
  };
};

export const fetchChats = (room_id, page) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_CHATS,
      payload: { room_id: room_id, page: page },
    });
    dispatch(startLoader());
  };
};

export const fetchChatsSuccess = (data) => {
  return {
    type: FETCH_CHATS_SUCCESS,
    payload: data,
  };
};

export const fetchCalls = (room_id) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_CALLS,
      payload: { room_id: room_id },
    });
    dispatch(startLoader());
  };
};

export const fetchCallsSuccess = (data) => {
  return {
    type: FETCH_CALLS_SUCCESS,
    payload: data,
  };
};
